// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2AbzJ","notes":"Notes_notes__1S727","note":"Notes_note__1lSxZ","markdown":"Notes_markdown__1GdPA"};